// @core/api/endpoints/form/list_form_submissions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListFormSubmissionsResponse,
} from '../../../types/form';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/form';

/**
 * List form submissions
 * Returns all submissions for a form. Supports filtering by status and date range.
 */
export async function ListFormSubmissions(
  form_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListFormSubmissionsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:form_id/submissions`;
  requestPath = requestPath.replace(':form_id', encodeURIComponent(form_id));
  const requestOptions = options;
  return client.get<ListFormSubmissionsResponse>(requestPath, { ...requestOptions, params });
}
